import React from "react";
import { ReactComponent as Name_Tag } from "../../assets/icons/nameTag.svg";
// import { ReactComponent as LinkedinIcon} from "../../assets/icons/linkedinColoured.svg";
import { ReactComponent as LinkedinIcon } from "../../assets/icons/linkedinWhite.svg";

export default function TeamCard({ isVisible, onToggle, ...props}) {
  /**
   * Show the QandA card.
   */
  const showCard = () => {
    if (!isVisible) {
      onToggle();
    }
  }

  /**
   * Hide the QandA card.
   */
  const hideCard = () => {
    if (isVisible) {
      onToggle();
    }
  }

  return (
    <div className="team-card">
      <div className="image-container">
        <img src={props.image} alt={`portrait image for ${props.name}`} />
        <div className="image-overlay"></div>
        <div className={`fill-overlay ${isVisible ? "visible" : ""}`}></div>
      </div>
      {isVisible && (
        <div className="description-overlay">
          <p className="description-text">
            {props.desc} Q&A
          </p>
          
          <div className="q-and-a">
            {/* <p className="q-and-a-title">Q&A</p> */}
            <p className="question">Favourite TV show?</p>
            <p className="answer">{props.answer1}</p>
            <p className="question">Cabin in the woods or castle in <br/> the sky?</p>
            <p className="answer">{props.answer2}</p>
            <p className="question">Favourite colour?</p>
            <p className="answer">{props.answer3}</p>
            <p className="question">Random skill?</p>
            <p className="answer">{props.answer4}</p>
            {/* <p className="question">Random skill?</p>
            <p className="answer">Counting sheep</p> */}
          </div>
          {/* <a
            href="https://www.linkedin.com/in/aleks-mitic-48600a264/"
            target="_blank"
            rel="noreferrer">
            <LinkedinIcon className="icon-center" />
          </a> */}
        </div>
      )}
      {/* <div className="team-card-text"> */}
      {props.linkedin !== "" && (
        <a
          href={props.linkedin}
          target="_blank"
          rel="noreferrer"
          className="linkedinLink"
        >
          <LinkedinIcon className="linkedinIcon" />
        </a>
      )}
      <div className="team-card-text">
        <div className="float-text">
          <p className="name">{props.name}</p>
          <p className="job-title">{props.jobTitle}</p>
        </div>

      </div>
    </div>
  )
}